export enum ColorsEnum {
  PINK = '#E23749',
  ORANGE = '#E95C30',
  PURPLE = '#6D2B48',
  BLUE = '#232148',
  GRAY = '#EEEEEF',
  WHITE = '#FFFFFF',
  BLACK = '#000000',
}
